import { RcClasses, spacing, typography } from '../../../foundation';
export var RcTooltipClasses = RcClasses([
    'popper',
    'tooltip',
    'arrow',
    'tooltipPlacementBottom',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
], 'RcTooltip');
export var RcTooltipTypography = {
    medium: typography('caption1'),
    large: typography('body1'),
    xlarge: typography('body1'),
};
export var RcTooltipSpace = {
    medium: spacing(2),
    large: spacing(3),
    xlarge: spacing(3),
};
export var RcTooltipPadding = {
    medium: spacing(1, 2),
    large: spacing(1, 2),
    xlarge: spacing(3, 3),
};
